import { render, staticRenderFns } from "./content.vue?vue&type=template&id=7265f3c7&"
import script from "./content.vue?vue&type=script&lang=js&"
export * from "./content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7265f3c7')) {
      api.createRecord('7265f3c7', component.options)
    } else {
      api.reload('7265f3c7', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=7265f3c7&", function () {
      api.rerender('7265f3c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/blocks/ImageWithButtonsBlock/components/content.vue"
export default component.exports